import times from 'lodash/times';

import {
  QuestionSubTypeEnum,
  QuestionTypeEnum,
  RatingLabelComponent,
  UpdateQuestionEntity,
} from '@/types/schema';

import { RATING_LEVELS } from '../../components/QuestionsView/components/RatingLabels/utils';
import { UserSurveyEditorQuestionFragment } from '../../graphql/fragments/generated/UserSurveyEditorQuestion';

export const DEFAULT_RATING_LABELS: RatingLabelComponent[] = times(RATING_LEVELS).map((index) => ({
  labelName: `Level ${index + 1}`,
  rating: index + 1,
}));

export const adaptUserSurveyQuestionInput = (
  question: UserSurveyEditorQuestionFragment,
): UpdateQuestionEntity => {
  const questionOptions = question.options ?? [];
  // const correctOptionsById = keyBy(question.correctOptions, 'optionId');
  const options = questionOptions.map((option) => ({
    ...option,
    optionEvaluation: false,
  }));

  const customRatingComponent =
    question.questionType === QuestionTypeEnum.Likert &&
    question.subType === QuestionSubTypeEnum.CustomRating
      ? question.customRatingComponent || { ratingLabels: DEFAULT_RATING_LABELS }
      : undefined;

  return {
    id: question.id,
    status: question.status,
    questionText: question.questionText,
    description: question.description,
    questionType: question.questionType,
    themeIds: { set: question.themeIds ?? [] },
    settings: question.settings,
    options: { set: options },
    subType: question.subType,
    customRatingComponent,
    subWorkspaceIds: { set: question.subWorkspaces ?? [] },
  };
};
